function Footer() {
  return (
    <footer style={{ padding: "20px", background: "#0B406E", textAlign: "center" }}>
      <p style={{fontSize:"12px", color:"#FFFFFF"}}>© {new Date().getFullYear()} Kronicle Research Pvt. Ltd. All rights reserved.</p>
    </footer>
  );
}

export default Footer;